<template>
  <section class="page-mobile">
    <header class="header">
      <h1 class="logo-text">Super File Manager</h1>
      <!-- <section class="name">File Magic</section> -->
      <div class="nav">
        <a class="mail" href="mailto:camelliaahk@gmail.com">SUPPORT</a>
        <a
          class="privacy"
          target="_blank"
          href="https://sites.google.com/view/superfilemanagerprivacypolicy?usp=sharing"
          >Privacy Policy</a
        >
        <a
          class="terms"
          target="_blank"
          href="https://docs.google.com/document/d/1Bu2zpFDB_TQMnfH6U_MWeWgf14DE1mDA3U70K4mG-rA/edit?usp=sharing"
          >User Agreement</a
        >
      </div>
    </header>
    <div class="main">
      <img class="logo" src="@/assets/images/sfm-logo.png" />
      <p class="text">Super File Manager</p>
      <p class="desc">Simple file manager & explorer, easily searching your files, folders and doc.</p>
      <div class="downloads">
        <a
          href="https://play.google.com/store/apps/details?id=com.file.manager.explorer.android"
        >
          <img class="googlePlay" src="@/assets/images/google-play.png" alt />
        </a>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'page-mobile',
  props: ['app'],
  beforeCreate () {
    const { $isServer } = this
    if ($isServer) return
    // eslint-disable-next-line no-new-func
    const fn = new Function(
      `(function(doc,win){var docEl=doc.documentElement;var resizeEvt="orientationchange" in window?"orientationchange":"resize";var recalc=function(){var clientWidth=docEl.clientWidth;if(!clientWidth){return}if(clientWidth>=720){docEl.style.fontSize="100px"}else{docEl.style.fontSize=100*(clientWidth/720)+"px"}};if(!doc.addEventListener){return}win.addEventListener(resizeEvt,recalc,false);recalc()})(document,window);`
    )
    fn()
  },
  computed: {
    slogen () {
      return this.app
        ? 'Bravo Booster Faster Than Ever'
        : 'Professional monitor of mobile virus, All-in-one security master of your device'
    },
    logoText () {
      return this.app ? 'Bravo Booster' : 'Bravo Security'
    },
    appName () {
      return this.app ? 'Bravo Booster' : 'Bravo Security'
    },
    download () {
      return this.app
        ? 'https://play.google.com/store/apps/details?id=com.bravo.booster&hl=en_SG&gl=US'
        : 'https://play.google.com/store/apps/details?id=com.topsecurity.android'
    }
  }
}
</script>
<style lang="less">
.container {
  max-width: 720px;
  margin: 0 auto;
}
.page-mobile {
  min-height: 100%;
  background: url(../../assets/images/sfm-bg.png) no-repeat;
  background-size: cover;
  background-position: center center;
  padding: 0.1px;
  .header {
    font-size: 0;
    display: flex;
    justify-content: space-between;
    padding: 0 48px;
    margin-top: 31.33px;
    .logo {
      height: 23px;
    }
    .logo-text {
      font-size: 0.2rem;
      margin: 0;
      color: #fff;
    }
    .name {
      font-size: 28px;
      color: #fff;
    }
    .nav {
      .mail,
      .privacy,
      .terms {
        color: #fff;
        font-weight: 700;
        font-size: 22px;
        line-height: 1.36;
      }
      .mail,
      .privacy {
        margin-right: 26.67px;
      }
    }
  }
  .main {
    font-size: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    bottom: .2rem;
    .logo {
      width: 161px;
      margin-top: 480px;
    }
    .name {
      width: 116px;
      margin-top: 18.67px;
    }
    .text {
      font-weight: bold;
      color: #fff;
      font-size: 50px;
      margin-top: 40px;
    }
    .desc {
      max-width: 80%;
      font-family: HelveticaNeue-LightItalic;
      font-size: 36px;
      color: transparent;
      letter-spacing: 3.73px;
      text-align: center;
      margin-top: 80px;
    }
    .downloads {
      display: flex;
      flex-direction: column;
      margin-top: 60px;
    }
    .appStore,
    .googlePlay {
      width: 260px;
      border-radius: 6px;
    }
    .appStore {
      margin: 80.67px 0 26.67px;
    }
    .googlePlay {
      margin: 0 0 26.67px;
    }
  }
}
</style>
